import type { ReactNode } from "react";

type CashierContextBarV2Props = {
  identity: ReactNode;
  customer?: ReactNode;
  financialStatus?: ReactNode;
  preparationStatus?: ReactNode;
  actions?: ReactNode;
};

/**
 * Approved order-context row.
 * Presentation only: callers provide current Production state and handlers.
 * The complete order cluster follows the cart column when language direction changes.
 */
export function CashierContextBarV2({
  identity,
  customer,
  financialStatus,
  preparationStatus,
  actions
}: CashierContextBarV2Props) {
  return (
    <div className="cashier-v2-contextbar" data-testid="cashier-v2-contextbar">
      <div className="cashier-v2-contextbar__order-cluster">
        <div className="cashier-v2-contextbar__identity">{identity}</div>
        {customer ? <div className="cashier-v2-contextbar__customer">{customer}</div> : null}
        {financialStatus ? <div className="cashier-v2-contextbar__status cashier-v2-contextbar__status--financial">{financialStatus}</div> : null}
        {preparationStatus ? <div className="cashier-v2-contextbar__status cashier-v2-contextbar__status--preparation">{preparationStatus}</div> : null}
        {actions ? <div className="cashier-v2-contextbar__actions">{actions}</div> : null}
      </div>
    </div>
  );
}
